import { createLogger, LogLevel } from './logger';
const logger = createLogger('CatalogModalsDOM', LogLevel.INFO);

// Утилиты для работы с DOM

/**
 * Создаёт элемент с классом и атрибутами
 */
export function createElement<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  className?: string,
  attrs?: Record<string, string>
): HTMLElementTagNameMap[K] {
  const el = document.createElement(tag);
  if (className && className.trim()) el.className = className;
  if (attrs) {
    Object.entries(attrs).forEach(([key, value]) => {
      el.setAttribute(key, value);
    });
  }
  
  // Логируем только переданные параметры
  const logParams: any[] = [tag];
  if (className && className.trim()) logParams.push(className);
  if (attrs) logParams.push(attrs);
  logger.info('Создан элемент', ...logParams);
  
  return el;
}

/**
 * Очищает содержимое элемента
 */
export function clearElement(el: HTMLElement): void {
  logger.info('Очищаю элемент', el);
  while (el.firstChild) {
    el.removeChild(el.firstChild);
  }
}

/**
 * Добавляет несколько детей к элементу
 */
export function appendChildren(parent: HTMLElement, ...children: (HTMLElement | string)[]): void {
  logger.info('Добавляю детей к элементу', parent, children);
  children.forEach(child => {
    if (typeof child === 'string') {
      parent.appendChild(document.createTextNode(child));
    } else {
      parent.appendChild(child);
    }
  });
} 